import store from "@/store";
import { CheckAuthorizeStatusAsync,
    CheckAuthorizeStatusAsyncAndCloseModal,
    CheckSubscriptionStatusAndCloseModalAsync, CheckSubscriptionStatusAsync } from "../authService";

export async function getEmployerVacanciesAsync(page){
    const url = `${process.env.VUE_APP_API_URL}Vacancy/GetAll?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response.clone());
    return response.json();

}

export async function searchEmployerVacanciesAsync(data,page){
    
    const url = `${process.env.VUE_APP_API_URL}Vacancy/Search?pageNumber=${page}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    await CheckAuthorizeStatusAsync(response.clone());
    return response.json();

}

export async function changeVisibilityAsync(jobId){
    
    const url = `${process.env.VUE_APP_API_URL}Vacancy/Visibility/${jobId}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckSubscriptionStatusAsync(response);
    await CheckAuthorizeStatusAsync(response);
    return response.json();

}

export async function deleteVacancyAsync(jobId){
    
    const url = `${process.env.VUE_APP_API_URL}Vacancy/Delete/${jobId}`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();

}

export async function editVacancyAsync(body, closeModal){
    const url = `${process.env.VUE_APP_API_URL}Vacancy/Edit`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });

    let checkSubscriptionResponse = response.clone();
    let checkAuthorizeStatusResponse = response.clone();

    await CheckSubscriptionStatusAndCloseModalAsync(checkSubscriptionResponse, closeModal);
    
    //await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
    await CheckAuthorizeStatusAsyncAndCloseModal(checkAuthorizeStatusResponse, closeModal);
    return response.json();

}

export async function addVacancyAsync(body, closeModal){
    const url = `${process.env.VUE_APP_API_URL}Vacancy/Add`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        },
        body: JSON.stringify(body)
    });

    let checkSubscriptionResponse = response.clone();
    let checkAuthorizeStatusResponse = response.clone();

    await CheckSubscriptionStatusAndCloseModalAsync(checkSubscriptionResponse, closeModal);
    
    // await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
    await CheckAuthorizeStatusAsyncAndCloseModal(checkAuthorizeStatusResponse, closeModal);
    return response.json();

}

export async function deleteAllVacanciesAsync(){
    const url = `${process.env.VUE_APP_API_URL}Vacancy/DeleteAll`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':`Bearer ${token}`
        }
    });
    await CheckAuthorizeStatusAsync(response.clone());
    return response.json();

}